import { INTEREST_SERVICE_VALID_PERCENTAGES } from "lib/constants";

const interestServicingPercentageResolver = (value) => {
  const asInt = parseInt(value);

  if (Object.values(INTEREST_SERVICE_VALID_PERCENTAGES).includes(asInt)) {
    return asInt;
  } else {
    return INTEREST_SERVICE_VALID_PERCENTAGES[100];
  }
};

export default interestServicingPercentageResolver;
